import EventRepository from '@/repositories/EventRepository'
import SnapsnapGateway from '@/gateways/SnapsnapGateway'
import { UchinokoData } from '@/types/domain/uchinoko'

export interface ISearchEventUchinokoPhotosUseCaseParams {
  eventRepository: EventRepository
  snapsnapGateway: SnapsnapGateway
}

export default class SearchEventUchinokoPhotosUseCase implements BaseUseCase {
  eventRepository: EventRepository
  snapsnapGateway: SnapsnapGateway

  constructor({ eventRepository, snapsnapGateway }: ISearchEventUchinokoPhotosUseCaseParams) {
    this.eventRepository = eventRepository
    this.snapsnapGateway = snapsnapGateway
  }

  async execute(params: { eventId: number; recommend?: boolean; ignoreOrderHistory?: boolean }): Promise<UchinokoData[]> {
    try {
      const data = await this.snapsnapGateway.C4.eventUchinokoSearch(params)
      const { eventId } = params
      this.eventRepository.saveUchinokoData({ eventId, data })
      const similarities: {
        photo_id: number
        similarity: number
      }[] = []
      data.forEach(d => {
        similarities.push(...d.similarities)
      })
      this.eventRepository.saveSimilarities(similarities)
      return data
    } catch (error) {
      throw error
    }
  }
}
